<template>
  <div class="col-sm-12 nopads">
      <h2 class="editor-header">{{ groupUpdate.id > 0 ? $t('area_groups.edit') : $t('area_groups.add')}}</h2>
      <div class="col-sm-12 editor-form nopads">
          <div class="col-sm-12 form-data nopads">
        <span class="span-title">
          {{ $t('area_groups.name') }}
        </span>
        <input
          id="name"
          v-model="groupUpdate.name"
          class="form-control form-control-mb"
          type="text"
        >
        <span
          class="span-title"
        >{{ $t('common.inactivate') }}</span>
        <div class="form-check">
          <input
            id="isInactive"
            v-model="groupUpdate.is_inactive"
            class="form-check-input"
            type="checkbox"
          >
        </div>

        <h4 class="form-header">
          {{ $t('area_groups.selected_areas') }}
        </h4>
        <div
          v-if="groupUpdate.areas.length > 0"
          class="col-sm-12 inspectable-container"
        >
          <div
            v-for="item in groupUpdate.areas"
            :key="item.id"
            :class="{'d-inline' : true}"
          >
            <span
              class="inspectables inspectables-selected"
              @click="removeFromSelection(item)"
            >
              {{ item.name }}
            </span>
          </div>
        </div>
        <div
          v-else
          class="col-sm-12 small-pad"
        >
          <span>
            {{ $t('area_groups.no_areas_selected') }}
          </span>
        </div>
        <!-- Available areas -->
        <h4 class="form-header">
          {{ $t('area_groups.available_areas') }}
        </h4>
        <!-- Filter -->
        <div class="row mb-3">
          <div class="col-sm-6 nopads pl-1 pr-1">
            <span
              v-if="groupUpdate.areas.length !== areas.length"
              class="span-title"
            >
              {{ $t('areas.type') }}
            </span>
            <select
              id="area"
              v-model="typeFilter"
              class="form-select form-select-sm sm-3"
            >
              <option
                v-for="option in areaTypes"
                :key="option.value"
                :value="option.value"
              >
                {{ option.text }}
              </option>
            </select>
          </div>
          <div class="col-sm-6 nopads pl-1 pr-1">
            <span
              v-if="groupUpdate.areas.length !== areas.length"
              class="span-title"
            >
              {{ $t('areas.name') }}
            </span>
            <input
              v-model="nameQuery"
              class="form-control form-control-sm"
              type="text"
            >
          </div>
        </div>
        <!-- Area selection options -->
        <div class="row inspectable-container" style="padding-left: .75em" >
          <div
            v-for="item in visibleAreas"
            :key="item.id"
            class="col-sm-6 col-md-4 col-lg-3 col-xl-2 inline inspectables nopads"
            :class="{ 'inspectables-disabled' : isAreaSelected(item.id) }"
            @click="addToSelection(item)"
          >
            {{ item.name }}
          </div>
        </div>
        <div class="col-12 d-flex justify-content-end">
          <button
            class="form-button btn btn-info"
            :disabled="loading || visibleAreas.length < 1"
            @click.stop="addAll"
          >
            {{ $t('common.add_all') }}
          </button>
        </div>
        <hr/>
        <div class="col-sm-12 button-container">
          <button
            class="form-button btn btn-danger"
            @click.stop="$emit('close')"
          >
            {{ $t('common.cancel') }}
          </button>
          <button
            class="form-button btn btn-success"
            :disabled="loading || groupUpdate.name === '' || groupUpdate.areas.length <= 0"
            @click.stop="submitAreaGroup"
          >
            {{ $t('common.save') }}
          </button>
        </div>
      </div>
    </div>
    <div
      v-if="loading"
      id="loader"
      class="spinner"
    />
  </div>
</template>

<script>
import {restApi} from '../../mixins/RestApiMixin'
import {inject} from "vue";

export default {
    name: 'AreaGroupEditor',
    mixins: [restApi],
    props: {
        areaGroup: {
            type: Object,
            default: null
        }
    },
    setup() {
        // Inject parents alerter
        const showAlert = inject('showAlert');
        return { showAlert };
    },
    data: function () {
        return {
            loading: false,
            areas: [],
            visibleAreas: [],
            areaTypes: [],
            typeFilter: null,
            nameQuery: '',
            groupUpdate: JSON.parse(JSON.stringify(this.areaGroup))
        }
    },
    watch: {
        nameQuery: function() {
            this.filterAreas()
        },
        typeFilter: function() {
            this.filterAreas()
        }
    },
    mounted: function () {
       this.fetchAreaTypes()
        this.fetchAreas()
    },
    methods: {

        filterAreas() {
            this.visibleAreas = []
            if (this.areas) {
                if ((this.nameQuery && this.nameQuery.length > 1) || this.typeFilter) {
                    this.areas.forEach(area => {
                        // Check name
                        let nameMatch = true
                        if (this.nameQuery && this.nameQuery.length > 1 && area.name.toLowerCase().indexOf(this.nameQuery.toLowerCase()) < 0) {
                            nameMatch = false
                        }
                        // Check type
                        let typeMatch = true
                        if (this.typeFilter) {
                            if (this.typeFilter.id !== area.type.id) {
                                typeMatch = false
                            }
                        }
                        if (nameMatch && typeMatch) {
                            this.visibleAreas.push(area)
                        }
                    })
                } else {
                    this.visibleAreas = this.areas
                }
            }
        },

        addAll() {
            this.visibleAreas.forEach(area => this.addToSelection(area))
        },

        fetchAreas: function () {
            this.areas = []
            this.loading = true
            this.restFetchParams(this.areaUrl, {no_geom: 1}, this.handleAreaFetchResponse)
        },

        handleAreaFetchResponse: function (response) {
            this.loading = false
            this.areas = response.data
            this.filterAreas()
        },

        removeFromSelection: function (area) {
            var index = this.groupUpdate.areas.findIndex(function (obj) {
                return obj.id === area.id
            })
            if (index >= 0) {
                this.groupUpdate.areas.splice(index, 1)
            }
        },

        addToSelection: function (area) {
            var index = this.groupUpdate.areas.findIndex(function (obj) {
                return obj.id === area.id
            })
            if (index < 0) {
                this.groupUpdate.areas.push(area)
            }
        },

        isAreaSelected: function (id) {
            return this.groupUpdate.areas.some(obj => obj.id === id)
        },

        checkValues: function (group) {
            if (group.name === '') {
                this.showAlert(this.$t('area_groups.invalid_name'))
                return undefined
            }
            if (group.areas.length <= 0) {
                this.showAlert(this.$t('area_groups.invalid_areas'))
                return undefined
            }
            return group
        },

        submitAreaGroup: function () {
            let areaGroupJson = JSON.parse(JSON.stringify(this.checkValues(this.groupUpdate)))
            if (areaGroupJson !== undefined) {
                this.loading = true
                areaGroupJson.areas = areaGroupJson.areas.map(obj => {
                    return {id: obj.id}
                })
                if (this.groupUpdate.id < 1) {
                    this.restAdd(this.areaGroupUrl, areaGroupJson, this.areaGroupSubmitSuccess, this.areaGroupSubmitFail)
                } else {
                    this.restUpdate(this.areaGroupUrl, areaGroupJson, this.areaGroupSubmitSuccess, this.areaGroupSubmitFail)
                }
            }
        },

        areaGroupSubmitSuccess: function () {
            this.$emit('closeAndUpdate')
            this.loading = false
        },

        areaGroupSubmitFail: function () {
            this.showAlert(this.$t('common.alert_update_failed'))
            this.loading = false
        },

        fetchAreaTypes: function () {
            this.loading = true
            this.restFetch(this.areaTypeUrl, this.handleAreaTypesResponse)
        },

        handleAreaTypesResponse: function (response) {
            this.loading = false
            this.areaTypes = []
            this.areaTypes.push({value: null, text: this.$t('areas.select_area_type')})
            response.data.forEach(type => {
                this.areaTypes.push({value: type, text: type.name})
            })
        }

    }
}
</script>
